import { all, takeEvery } from "redux-saga/effects";

import { userActions, userSagas } from "../ducks";

function* rootSaga() {
    yield all([
        takeEvery(userActions.getUsersAsync.request, userSagas.login)
    ]);
}

export default rootSaga;
